import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Dispatch, Action } from "redux";
import { useLayout } from "../../../../provider/LayoutProvider";
import { getAllCourses } from "../../../../store/actions/course";
import { CourseInDto } from "../../../../types/course.dto";
import useIsMobile from "../../../../hooks/deviceChecker";
import { List } from "./styles";
import InfinityScroll from "../../../../components/InfinityScroll";
import CourseEmptyCard from "../../../../components/CourseEmptyCard";
import CourseCard from "../../../../components/CourseCard";
import { useSelector } from 'react-redux';

interface ComponentProps {
  courses: CourseInDto[];
  coursesStates: {
    loading: boolean;
  };
}

const Component = ({ courses, coursesStates }: ComponentProps) => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch<Dispatch<Action>>();
  const [page, setPage] = useState(1);
  const [data, setData] = useState<CourseInDto[]>([]);
  const { setIsPageLoading, layout, setLayout, applyedFilters, resetFilters } = useLayout();
  const levelInfo = useSelector((state) => state.staticsStore?.data?.levels);

  const getCourses = ({ page }) => {
    dispatch(
      getAllCourses({
        pagination: {
          page,
          limit: 10,
        },
        filters: applyedFilters,
      })
    );
  };

  useEffect(() => {
    setLayout({
      ...layout,
      showFilters: true,
      showSearchBar: true,
      showBackButton: false,
      showSubHeader: !isMobile,
    })
  }, [isMobile]);

  useEffect(() => {
    if (!!applyedFilters && !!courses) {
      setData([]);
      setPage(1);
      getCourses({ page: 1 });
    }
  }, [applyedFilters]);

  useEffect(() => {
    if (!coursesStates.loading && !!courses) {
      setData((state) => [...state, ...courses.map(course => ({ ...course }))]); // Evitando mutación
    }
  }, [courses, coursesStates]);

  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, []);

  useEffect(() => {
    if (!data || coursesStates.loading) {
      setIsPageLoading(true);
    } else {
      setIsPageLoading(false);
    }
  }, [coursesStates, data]);

  return (
    <>
      <div style={{ height: 10 }} />
      <InfinityScroll
        loader={
          <>
            {!!data && <div style={{ height: 16 }} />}
            <List>
              {Array.from({ length: page === 1 ? 10 : 1 }, (_, index) => (
                <CourseEmptyCard key={index} />
              ))}
            </List>
          </>
        }
        action={getCourses}
        page={page}
        setPage={setPage}
        data={data}
        active={!!courses && courses.length > 0}
        isLoading={coursesStates.loading}
        style={{ padding: 10 }}
      >
        <List>
          {
            data?.map((content) => (
              <CourseCard course={content} levels={levelInfo} key={content.id} />
            ))
          }
        </List>
      </InfinityScroll>
    </>
  );
};

const state = ({ courseStore }) => {
  const { data: courses, states: coursesStates } = courseStore.getAll;

  return {
    courses,
    coursesStates,
  };
};

export default connect(state)(Component);
